// extracted by mini-css-extract-plugin
export default {"wrapper":"DefaultAutoCompleteInput_wrapper__0cdgB","optionsList":"DefaultAutoCompleteInput_optionsList__L6OV3","option":"DefaultAutoCompleteInput_option__QZ7xA"};